<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page" class="flex items-center space-x-2">
          <template v-if="adminLogo">
            <img :src="adminLogo" alt="logo" style="height: 28px; object-fit: contain" />
          </template>
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import { ref, onMounted } from 'vue'
import settingsService from '../../services/settings.service'
import AppNavbarActions from './components/AppNavbarActions.vue'

import { getImageURL } from '../../config/api'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
const adminLogo = ref<string>('')
const adminName = ref<string>('')

onMounted(async () => {
  try {
    const settings = await settingsService.getAllSettings()
    if (settings.admin_logo?.value) {
      const val = settings.admin_logo.value
      // Check if value is object (old format) or string
      if (typeof val === 'object' && val.url) {
        adminLogo.value = getImageURL(val.url)
      } else if (typeof val === 'string') {
        adminLogo.value = getImageURL(val)
      }
    }
    if (settings.admin_name?.value) adminName.value = settings.admin_name.value
  } catch (e) {
    // ignore
  }
})
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
